/**
 * Locale helpers for components that need setLocale without digging into i18n.
 */
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { setAppLocale, readStoredLocale, SUPPORTED_LOCALES, DEFAULT_LOCALE } from './index';

export function useLocale() {
  const { i18n } = useTranslation();
  const locale = SUPPORTED_LOCALES.includes(i18n.language)
    ? i18n.language
    : (readStoredLocale() || DEFAULT_LOCALE);

  const setLocale = useCallback(async (next) => {
    await setAppLocale(next);
  }, []);

  return { locale, setLocale, locales: SUPPORTED_LOCALES };
}
